import {Typography} from "@mui/material";
import {connect} from "react-redux";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
  }) => ({
    i18n,
    isLoading,
  }),
  {
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  return (
    <div className="card-service abo-card">
      <Typography variant="h1">{i18n.abo_title}</Typography>
      <span className="text">
        Gewünschtes Abo im nächsten Schritt auswählen
      </span>
    </div>
  );
});
